import { joiResolver } from "@hookform/resolvers/joi";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import VmoBrandLogo from "../Custom/VmoBrandLogo";
import VmoForm from "../Collections/VmoForm/VmoForm";
import VmoFormInput from "../Collections/VmoForm/VmoFormInput";
import VmoFormField from "../Collections/VmoForm/VmoFormField"
import VmoButton from "../Elements/VmoButton/VmoButton"
import VmoCardContent from "../Views/VmoCard/VmoCardContent";
import { paswordSchema } from "../Validation/common.schema";
import VmoCard from "../Views/VmoCard/VmoCard";
import VmoContainer from "../Elements/VmoContainer";
import PropTypes from 'prop-types';

export default function VmoPasswordReset({
    header,
    subHeader,
    disabled,
    loading,
    onSubmit,
    btnLabel,
    testIds = {}
}) {
    const [requestId, setRequestId] = React.useState(null);
    const {
        handleSubmit,
        control,
        formState: { errors },

    } = useForm({
        mode: 'onTouched',
        shouldFocusError: true,
        reValidateMode: 'onChange',
        submitFocusError: true,
        shouldUnregister: false,
        resolver: joiResolver(paswordSchema),
        defaultValues: {
            password: ''
        }
    });
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const requestId = urlParams.get('requestId');
        if (requestId) {
            setRequestId(requestId)
        }
    }, []);
    const onPassowrdSubmit = (data) => {
        const e = {
            ...data,
            requestId
        }
        onSubmit(e)
    }
    return (
        <React.Fragment>
            <VmoContainer data-testid={testIds.container || "vmo-password-reset-container"}>
                <div className="signInPageHeader">
                    <VmoBrandLogo className={'veemo-logo'} data-testid={testIds.logo || "veemo-logo"} />
                </div>
                <div className="signInPage">
                    <div className="signInBody">
                        <h2>{header}</h2>
                        <VmoCard className="loginCard otpCard" data-testid={testIds.card || "password-reset-card"}>
                            <VmoCardContent>
                                <VmoForm className="errorLabel">
                                    <VmoFormField required >
                                        <Controller
                                            name="password"
                                            control={control}
                                            render={({ field: { value, onChange }, }) => (
                                                <VmoFormInput
                                                    fluid
                                                    placeholder="Type New Password"
                                                    type="password"
                                                    value={value}
                                                    onChange={onChange}
                                                    error={
                                                        errors.password && {
                                                            content: errors.password?.message,
                                                        }
                                                    }
                                                    data-testid={testIds.passwordInput || "password-input"}
                                                />
                                            )}
                                        />
                                    </VmoFormField>
                                    <VmoFormField >
                                        <VmoButton
                                            primary
                                            size="large"
                                            fluid
                                            className="mt-1"
                                            disabled={disabled}
                                            loading={loading}
                                            onClick={handleSubmit(onPassowrdSubmit)}
                                            data-testid={testIds.submitButton || "submit-button"}
                                        >
                                            {btnLabel}
                                        </VmoButton>
                                    </VmoFormField>
                                </VmoForm>
                            </VmoCardContent>
                        </VmoCard>
                    </div>
                </div>
            </VmoContainer>
        </React.Fragment>
    );
}

VmoPasswordReset.defaultProps = {
    header: 'Enter New Password',
    disabled: false,
    loading: false,
    onSubmit: () => { },
    btnLabel: 'Create New Password',
    testIds: {}
};

VmoPasswordReset.propTypes = {
    header: PropTypes.string,
    subHeader: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    btnLabel: PropTypes.string,
    testIds: PropTypes.shape({
        container: PropTypes.string,
        logo: PropTypes.string,
        card: PropTypes.string,
        passwordInput: PropTypes.string,
        submitButton: PropTypes.string
    })
};
